var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-typer',{staticClass:"font-medium",attrs:{"text":_vm.text,"repeat":Infinity,"shuffle":false,"initial-action":"typing","pre-type-delay":70,"type-delay":80,"pre-erase-delay":1300,"erase-delay":30,"erase-style":"backspace","erase-on-complete":false,"caret-animation":"smooth"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }